var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowRightBlack(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 6.415,
    height: 10.881,
    viewBox: "0 0 6.415 10.881"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M.474,5.941l4.94,4.94,1-1L1.989,5.44,6.415,1l-1-1L.474,4.94,0,5.44Z",
    transform: "translate(6.415 10.881) rotate(180)"
  })));
}
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI2LjQxNSIgaGVpZ2h0PSIxMC44ODEiIHZpZXdCb3g9IjAgMCA2LjQxNSAxMC44ODEiPjxwYXRoIGQ9Ik0uNDc0LDUuOTQxbDQuOTQsNC45NCwxLTFMMS45ODksNS40NCw2LjQxNSwxbC0xLTFMLjQ3NCw0Ljk0LDAsNS40NFoiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDYuNDE1IDEwLjg4MSkgcm90YXRlKDE4MCkiLz48L3N2Zz4=";
export { SvgArrowRightBlack as ReactComponent };